export interface EncounterDateFilter {
  dischargeFrom: Date | null;
  dischargeTo: Date | null;
}

/**
 * `discharge_datetime` is nullable (not-yet-discharged encounters). Rows with a
 * null discharge date are excluded whenever a date-range filter is active, since
 * they can't be evaluated against a range — they're still reachable via the
 * direct encounter-id lookup.
 */
export function hasActiveDateFilter(filter: EncounterDateFilter): boolean {
  return filter.dischargeFrom !== null || filter.dischargeTo !== null;
}
